import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "@/lib/site";
import { FadeUp } from "@/components/Reveal";

const Beyond = () => {
  const reduced = useReducedMotion();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], ["-8%", reduced ? "-8%" : "8%"]);

  return (
    <section
      data-chapter="05"
      data-testid="beyond-section"
      ref={ref}
      className="relative overflow-hidden bg-walnut py-32 text-ivory lg:py-48"
    >
      <motion.div
        className="pointer-events-none absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage: `url(${IMAGES.forestLight})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          y: bgY,
        }}
        aria-hidden="true"
      />
      <div className="relative mx-auto flex max-w-4xl flex-col items-center px-6 text-center">
        <FadeUp>
          <span className="mb-12 inline-block h-[6px] w-[6px] rounded-full bg-gold animate-dot-pulse" aria-hidden="true" />
        </FadeUp>
        <FadeUp delay={0.1}>
          <h2 className="font-serif text-4xl font-light leading-[1.1] tracking-tight sm:text-5xl lg:text-6xl" data-testid="beyond-headline">
            Relaxation is welcome.
            <span className="mt-2 block italic text-sand">Relief is the intention.</span>
          </h2>
        </FadeUp>
        <FadeUp delay={0.25}>
          <p className="mx-auto mt-12 max-w-2xl font-sans text-base font-light leading-relaxed tracking-wide text-ivory/75" data-testid="beyond-copy">
            A good massage works with the body. A great one also gives you
            time to slow down — allowing the body to settle, the mind to
            quiet, and recovery to take place.
          </p>
        </FadeUp>
        <FadeUp delay={0.35} className="mt-12">
          <Link
            to="/about"
            data-testid="beyond-about-link"
            className="group inline-flex items-center gap-4 rounded-full border border-ivory/25 px-10 py-4 font-sans text-[11px] font-medium uppercase tracking-[0.3em] text-ivory transition-colors duration-500 hover:border-gold hover:text-gold"
          >
            About
            <span className="h-[5px] w-[5px] rounded-full bg-gold transition-transform duration-500 group-hover:scale-150" aria-hidden="true" />
          </Link>
        </FadeUp>
        <FadeUp delay={0.4} className="mt-14 flex w-full max-w-xs items-center gap-4" >
          <span className="h-px flex-1 bg-gold/40" />
          <span className="font-sans text-[10px] uppercase tracking-[0.4em] text-gold">05 — Beyond Relaxation</span>
          <span className="h-px flex-1 bg-gold/40" />
        </FadeUp>
      </div>
    </section>
  );
};

export default Beyond;
